// Floating labels for Elementor forms

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.form-floating-label .elementor-field-group').forEach(function (group) {
    var field = group.querySelector('.elementor-field');
    if (!field) return;
    // Only apply for text, email, tel, and textarea fields
    var type = field.getAttribute('type');
    var isTextType = (
      type === 'text' ||
      type === 'email' ||
      type === 'tel' ||
      field.tagName.toLowerCase() === 'textarea'
    );
    if (!isTextType) return;
    var toggleFloating = function () {
      if (field.value.trim() !== '' || document.activeElement === field) {
        group.classList.add('floating-active');
      } else {
        group.classList.remove('floating-active');
      }
    };
    field.addEventListener('focus', toggleFloating);
    field.addEventListener('blur', toggleFloating);
    field.addEventListener('input', toggleFloating);
    // Initial state
    toggleFloating();
  });
});
